import { Tooltip, Zoom, IconButton, Typography, Grid } from '@mui/material';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@mui/material';
import axios from 'axios';
import { useEffect, useState } from 'react';
import { CircleLoader } from 'components';
import { MdOpenWith as EmailIcon, MdOutlineAttachment } from 'react-icons/md';
import moment from 'moment';
import { LocalizationIds } from 'helpers/Localizations';
import { useIntl } from 'react-intl';


interface ITicketInbox {
    subject: string
    date: moment.Moment
    senderEmail: string
    senderName: string
    htmlContent: string
    attachments: string[]
}

let ViewEmail = ({ id }: { id: string }) => {

    let { formatMessage } = useIntl();

    let [isOpen, setOpen] = useState(false);
    let [isLoading, setLoading] = useState(false);
    let [email, setEmail] = useState<ITicketInbox>();


    useEffect(() => {
        let getTicketInbox = async () => {
            try {
                let res = await axios.get('/api/TicketInbox/GetTicketInbox', { params: { id } });
                setEmail(res.data.item);
            } catch (err) { }
            finally {
                setLoading(false);
            }
        }

        if (isOpen === true)
            getTicketInbox();
    }, [isOpen])



    return (
        <>
            <Tooltip TransitionComponent={Zoom} title="Visualizza email">
                <IconButton size="small"
                    onClick={() => {
                        setLoading(true);
                        setOpen(true);
                    }}
                >
                    <EmailIcon />
                </IconButton>
            </Tooltip>

            <Dialog open={isOpen} fullWidth maxWidth="md">
                <DialogTitle>{formatMessage({ id: LocalizationIds.Date })}</DialogTitle>
                <DialogContent>
                    {isLoading && <CircleLoader />}
                    {isLoading === false &&
                        <Grid container>
                            <Grid item xs={2}>
                                <Typography>{formatMessage({ id: LocalizationIds.Sender })}</Typography>
                            </Grid>
                            <Grid item xs={10}>
                                <Typography>{email?.senderName}&nbsp;&middot;&nbsp;{email?.senderEmail}</Typography>
                            </Grid>

                            <Grid item xs={2}>
                                <Typography>Oggetto</Typography>
                            </Grid>
                            <Grid item xs={10}>
                                <Typography>{email?.subject}</Typography>
                            </Grid>

                            <Grid item xs={2} />
                            <Grid item xs={10}>
                                <Typography dangerouslySetInnerHTML={{ __html: email?.htmlContent || '' }} />
                            </Grid>

                            {(email?.attachments.length || 0) > 0 &&
                                <>
                                    <Grid item xs={2} />
                                    <Grid item xs={10}>
                                        {email?.attachments.map(filename => <><MdOutlineAttachment />&nbsp;{filename}</>)}
                                    </Grid>
                                </>
                            }
                        </Grid>
                    }
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpen(false)} color="secondary">Chiudi</Button>
                </DialogActions>
            </Dialog>
        </>
    )
}

export default ViewEmail;